import { PAYMENT_METHOD, PERSON_TYPE } from "@hub/offline-order/src/constants"
import { leftPad } from "@shared/helpers"

const getCustomerContactsPayload = contacts => {
  return contacts.map(({ type, value }) => {
    return {
      type,
      value
    }
  })
}

const getIndividualPersonPayload = customer => {
  return {
    document: customer.physical?.document,
    person_type: customer.person_type,
    name: customer.physical.name,
    birthdate: customer.physical.birthdate,
    gender: customer.physical.gender,
    general_registration: customer.physical.general_registration,
    mother_name: customer.physical.mother_name,
    father_name: customer.physical.father_name,
    schooled: customer.physical.schooled,
    marital_status: customer.physical.marital_status,
    profession: customer.physical.profession,
    contacts: getCustomerContactsPayload(customer.contacts),
    observation: customer.physical.note
  }
}

const getLegalPersonPayload = customer => {
  return {
    document: customer.legal?.document,
    person_type: customer.person_type,
    contacts: getCustomerContactsPayload(customer.contacts),
    observation: customer.legal.note,
    social_reason: customer.legal.social_reason,
    legal_type: customer.legal.person_legal_type,
    opening_date: customer.legal.opening_date,
    state_registration: customer.legal.state_registration,
    responsible: customer.legal.responsible
  }
}

const getPersonPayload = customer => {
  if (customer.person_type === PERSON_TYPE.INDIVIDUAL)
    return getIndividualPersonPayload(customer)

  return getLegalPersonPayload(customer)
}

const getAddressPayload = address => {
  return {
    postcode: address.postcode,
    state: address.state,
    city: address.city,
    address: address.address,
    neighborhood: address.neighborhood,
    number: address.number,
    complement: address.complements,
    observation: address?.address_note
  }
}

const getPaymentInfoPayload = sale => {
  const { payment_info } = sale.data
  const payload = {
    contract_type: payment_info.contract_type,
    due_day: payment_info.due_day,
    payment_type: payment_info.payment_type,
    shipping_method: payment_info.shipping_method,
    charge_address: payment_info.charge_address
  }

  if (sale.data.note) {
    payload.note = sale.data.note
  }

  if (payment_info.charge_address) {
    payload.address = getAddressPayload(payment_info.address)
  }

  if (payment_info.payment_type === PAYMENT_METHOD.DEBIT) {
    payload.automatic_debit = {
      bank: payment_info.automatic_debit.bank,
      agency: payment_info.automatic_debit.agency,
      account: payment_info.automatic_debit.account
    }
  }

  return payload
}

const getOffersArray = offers => {
  return offers.map(offer => offer.value)
}

const formatDateIsoStringToDb = date => {
  const dateObj = new Date(date)
  const day = leftPad(dateObj.getDate(), 2)
  const month = leftPad(dateObj.getMonth() + 1, 2)
  const year = dateObj.getFullYear()
  const hours = leftPad(dateObj.getHours(), 2)
  const minutes = leftPad(dateObj.getMinutes(), 2)

  return `${year}-${month}-${day} ${hours}:${minutes}`
}

export const getSalePayload = sale => {
  return {
    status: sale.data.status_to_sync,
    made_at: formatDateIsoStringToDb(sale.created_at),
    idempotency_key: sale.id,
    person: getPersonPayload(sale.data.customer),
    address: getAddressPayload(sale.data.address),
    offers: getOffersArray(sale.data.offers),
    payment_info: getPaymentInfoPayload(sale)
  }
}
